"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _ = require("../..");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var DateTimeInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DateTimeInput, _React$Component);

  function DateTimeInput() {
    _classCallCheck(this, DateTimeInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(DateTimeInput).apply(this, arguments));
  }

  _createClass(DateTimeInput, [{
    key: "handlePartChange",
    value: function handlePartChange(part, value) {
      var datetime = (0, _moment["default"])(this.props.value);

      if (part === "date") {
        var regex = /(\d\d\d\d)-(\d\d)-(\d\d)/;

        var _regex$exec = regex.exec(value),
            _regex$exec2 = _slicedToArray(_regex$exec, 4),
            year = _regex$exec2[1],
            month = _regex$exec2[2],
            day = _regex$exec2[3];

        datetime.year(year);
        datetime.month(parseInt(month) - 1);
        datetime.date(day);
      }

      if (part === "time") {
        var _regex = /(\d\d):(\d\d)/;

        var _regex$exec3 = _regex.exec(value),
            _regex$exec4 = _slicedToArray(_regex$exec3, 3),
            hour = _regex$exec4[1],
            minute = _regex$exec4[2];

        datetime.hour(hour);
        datetime.minute(minute);
      }

      this.props.onChange(datetime.toISOString());
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var datetime = (0, _moment["default"])(this.props.value);
      return _react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        spacing: 2
      }, _react["default"].createElement(_Grid["default"], {
        item: true
      }, _react["default"].createElement(_.Typography, {
        style: {
          lineHeight: '56px'
        }
      }, this.props.label)), _react["default"].createElement(_Grid["default"], {
        item: true
      }, _react["default"].createElement(_.DateInput, {
        value: datetime.format("YYYY-MM-DD"),
        onChange: function onChange(e) {
          return _this.handlePartChange("date", e.target.value);
        }
      })), _react["default"].createElement(_Grid["default"], {
        item: true
      }, _react["default"].createElement(_.TimeInput, {
        value: datetime.format("HH:mm"),
        onChange: function onChange(e) {
          return _this.handlePartChange("time", e.target.value);
        }
      })));
    }
  }]);

  return DateTimeInput;
}(_react["default"].Component);

exports["default"] = DateTimeInput;